// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QXdgq","reason":"styles_reason__pT1C7"};